<template>
  <div class="nav-left" :style="{ height: height + 'px' }">
    <el-menu class="el-menu-vertical-demo left-bar" ref="menu" :unique-opened="true" :collapse="isCollapse"
      :default-openeds="activeMenu" :default-active="activeApp">
      <!--
      <div @click="changeMode" class="change-mode pointer">
        <icon name="riv-tick"></icon>
      </div>
      -->

      <!--<el-menu-item index="HOME" :class="[(activeMenu.indexOf('HOME') >= 0) ? 'is-active-custom' : '']">
        <div class="titolo" @click="goToArea('home', 'HOME')">
          <icon name="riv-menuhome" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']">
          </icon>
        </div>
      </el-menu-item>

      <el-menu-item index="calendar" :class="[(activeMenu.indexOf('calendar') >= 0) ? 'is-active-custom' : '']">
        <div class="titolo" @click="goToArea('Calendar', 'calendar')">
          <icon name="riv-calendar2" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']">
          </icon>
        </div>
      </el-menu-item>-->


      <div v-for="(area, index) in menu" :key="index">


        <el-menu-item v-if="area.apps.length === 0" :index="area.area"
          :class="[(activeMenu.indexOf(area.area) >= 0) ? 'is-active-custom' : '']">
          <div class="titolo" @click="area.tipologia === 'rotta' ? goToArea(area, area.area) : ''">
            <icon :name="area.icon" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']"></icon>
          </div>
        </el-menu-item>
        <!-- DOCS SUBMENU-->
        <el-submenu v-if="area.area === 'DOCS'" :key="area.area" :index="area.area"
          :class="[(activeMenu.indexOf(area.area) >= 0) ? 'is-active-custom' : '']">
          <template slot="title">
            <div class="titolo">
              <icon :name="area.icon" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']"></icon>
            </div>
          </template>

          <el-menu-item class="intestazione-area" :index="area.area">
            <div class="label-area">
              {{ getLabel(area) }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in area.apps" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>
        </el-submenu>


        <!-- APPS SUBMENU-->
        <el-submenu v-if="area.area === 'APPS'" :index="area.area"
          :class="[(activeMenu.indexOf(area.area) >= 0) ? 'is-active-custom' : '']">
          <template slot="title">
            <div class="titolo">
              <icon :name="area.icon" scale="3.4" :class="['icon', (isIE10) ? 'ie10' : '']"></icon>
            </div>
          </template>

          <!-- SPORTELLO -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.SPORTELLO.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.SPORTELLO') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.SPORTELLO" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- ASSENZE -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.ASSENZE.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.ASSENZE') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.ASSENZE" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- DELEGHE SINDACALI -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.DELSIND.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.DELSIND') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.DELSIND" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- TRASFERTE -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.TRASFERTE.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.TRASFERTE') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.TRASFERTE" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- PRESENZE -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.PRESENZE.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.PRESENZE') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.PRESENZE" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- RICARICAAU -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.RICARICAAU.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.RICARICAAU') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.RICARICAAU" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

          <!-- SOSTITUTO -->
          <el-menu-item class="intestazione-area" :index="area.area" v-if="subMenu.SOSTITUTO.length > 0">
            <div class="label-area">
              {{ $t('navLeft.subMenu.SOSTITUTO') }}
            </div>
          </el-menu-item>
          <el-menu-item v-for="(item, index) in subMenu.SOSTITUTO" :key="item.codiApp" :index="item.codiApp"
            @click="goToApp(item, area.area)">
            <div class="label-menu">
              <icon name="riv-circle_2" scale="0.5"></icon>
              <div :class="['applicazione', (item.codiApp === activeApp) ? 'selected-app' : '']">{{ getLabel(item) }}
              </div>
            </div>
          </el-menu-item>

        </el-submenu>
      </div>

    </el-menu>


    <div class="servizi">
      <div class="linea"></div>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.app')" placement="top" :open-delay="1000">
        <div class="servizio pointer">
          <icon name="riv-luci-qr" scale="1.6" @click.native="() => {
            showModalApps = true
          }"></icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.info')" placement="top" :open-delay="1000"
        v-if="checkInfo">
        <div class="servizio pointer">
          <icon name="riv-help" scale="1.6" @click.native="selectMessage()"></icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.links')" placement="top" :open-delay="1000">
        <div class="servizio pointer">
          <icon name="riv-luci-link" scale="1.6" @click.native="loadLinks()"></icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.lingua.cambioLingua')" placement="top"
        :open-delay="1000">
        <div class="servizio pointer">
          <icon name="riv-luci-world" scale="1.6"
            @click.native="(lingua.languageDialogVisible = !lingua.languageDialogVisible)">
          </icon>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" :content="$t('navLeft.bottoni.logout')" placement="top" :open-delay="1000">
        <div class="servizio pointer">
          <icon name="riv-luci-log-out" scale="1.6" @click.native="logout"></icon>
        </div>
      </el-tooltip>
    </div>

    <el-dialog class="modal-lingua" :title="$t('navLeft.lingua.cambioLingua').toUpperCase()"
      :visible.sync="lingua.languageDialogVisible" :append-to-body="true"
      custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">
      <div style="height: auto">
        <div class="elemento">
          <span class="my-label">{{ $t('navLeft.lingua.linguaImpostata') + ': ' }}</span>
          <span><b>&emsp;{{ $t('navLeft.lingua')[codLang] }}</b></span>
        </div>
        <div class="elemento">
          <span class="my-label">{{ $t('navLeft.lingua.cambioLingua') }}</span>
          <div class="radio row row-custom">
            <el-radio v-model="lingua.lingua" label="it_IT" class="col-6 no-padding custom-radio"
              v-if="codLang !== 'it_IT'">{{ $t('navLeft.lingua.it_IT') }}
            </el-radio>
            <el-radio v-model="lingua.lingua" label="fr_FR" class="col-6 no-padding custom-radio"
              v-if="codLang !== 'fr_FR'">{{ $t('navLeft.lingua.fr_FR') }}
            </el-radio>
            <el-radio v-model="lingua.lingua" label="es_ES" class="col-6 no-padding custom-radio"
              v-if="codLang !== 'es_ES'">{{ $t('navLeft.lingua.es_ES') }}
            </el-radio>
            <el-radio v-model="lingua.lingua" label="de_DE" class="col-6 no-padding custom-radio"
              v-if="codLang !== 'de_DE'">{{ $t('navLeft.lingua.de_DE') }}
            </el-radio>
            <el-radio v-model="lingua.lingua" label="en_GB" class="col-6 no-padding custom-radio"
              v-if="codLang !== 'en_GB'">{{ $t('navLeft.lingua.en_GB') }}
            </el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-primary" @click="setLanguage" :disabled="(lingua === '')">
            {{ $t('navLeft.lingua.imposta').toUpperCase() }}
          </el-button>
        </div>
      </span>
    </el-dialog>

    <!-- MODAL APPS-->
    <el-dialog class="modal-link" :title="$t('navLeft.app').toUpperCase()" :visible.sync="showModalApps"
      :append-to-body="true"
      custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">
      <div style="Height: 100px; height: auto">
        <div class="row row-custom ">
          <div class="col-12">
            <div
              style="text-align: center; font-family: 'os-regular';font-weight: normal; font-size: 16px; color: #007c74">
              {{
                $t('navLeft.store_android') }}</div>
            <a target="_blank"
              href="https://play.google.com/store/apps/details?id=com.lucimobile&pcampaignid=web_share">
              <img style="width: 200px; display: block; margin-left: auto; margin-right: auto;"
                src="../../static/img/qr-LUCI-Android.png" />
            </a>
          </div>
          <div class="col-12">
            <div
              style="text-align: center; font-family: 'os-regular';font-weight: normal; font-size: 16px; color: #007c74">
              {{
                $t('navLeft.store_iOS') }}</div>
            <a target="_blank" href="https://apps.apple.com/app/riva-luci/id6475958287">
              <img style="width: 200px; display: block; margin-left: auto; margin-right: auto;"
                src="../../static/img/qr-LUCI-Apple.png" />
            </a>
          </div>
        </div>
      </div>
      <span slot="footer" class="footer">
      </span>
    </el-dialog>

    <!-- MODAL LINKS-->
    <el-dialog class="modal-link" :title="$t('navLeft.links').toUpperCase()" :visible.sync="showModalLinks"
      :append-to-body="true"
      custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-6 col-lg-12 offset-md-4 col-md-16 offset-sm-2 col-sm-20 offset-1 col-22">
      <div style="minHeight: 100px; height: auto" v-loading="loadingLink">
        <div class="elemento">
          <div v-for="link in links" class="col-lg-24 col-md-24 col-sm-24 col-24 no-padding" :key="link.titolo">
            <div class="linkDetail">
              <a target="_blank" :href="link.url">
                <span class="applicazione">{{ link.titolo }}</span> ({{ link.url }})
              </a>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="footer">
        <div class="col-24 no-padding">
          <el-button class="WEB-button WEB-button-alternative" @click="showModalLinks = false">{{
            $t('navLeft.bottoni.close') }}</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- MODAL INFORMATIVA -->
    <el-dialog class="modal-message" :visible.sync="showModalInfo" @close="closeMessages" width="600px"
      :append-to-body="true" :title="messaggio.titolo.toUpperCase()" custom-class="custom-dialog">

      <div class="col-24 no-padding data">
        {{ $t('navLeft.docs')[new Date(messaggio.dataPub.substr(0, 4), parseInt(messaggio.dataPub.substr(5, 2)) - 1,
          messaggio.dataPub.substr(8, 2)).getDay()] + ', ' + moment(messaggio.dataPub,
            'YYYY-MM-DD-HH.mm').format('DD/MM/YYYYHH:mm') }}
      </div>
      <!--<div class="col-24 no-padding data" v-if="(messaggio.hasOwnProperty('dataExp'))">
        {{ $t('navLeft.docs.scadenza') + ' ' + moment(messaggio.dataExp, 'YYYY-MM-DD').format('DD/MM/YYYY') }}
      </div>-->
      <div class="testo col-24 no-padding" v-html="messaggio.testo"></div>
      <div class="allegati col-24 no-padding" v-if="(messaggio.allegati.length > 0)">
        <div v-for="mess in messaggio.allegati" :key="mess.keyDoc">
          <div class="col-24 no-padding allegato" @click="getAllegato(mess)">
            <icon class="icona" name="riv-attach" scale="1"></icon>
            <div class="titolo-allegato">
              {{ mess.titolo }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <div class="col-24 no-padding">
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { bus } from './Bus'
import mixinDownload from "../assets/mixins/downloadDoc.js";

export default {
  name: 'NavLeft',
  mixins: [mixinDownload],
  props: {
    height: {
      type: Number,
      required: true,
      default: 650
    }
  },
  i18n: {
    messages: {
      it_IT: {
        navLeft: {
          contattaci: {
            contattaci: 'Contattaci',
            a: 'A',
            areeDiLavoro: 'Aree di Lavoro',
            oggetto: 'Oggetto',
            messaggio: 'Messaggio',
            allegato: 'Allegato',
            scegli: 'Scegli...',
            invia: 'Invia',
            stato: 'Stato',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'Spagna',
              4: 'Belgio',
              5: 'Germania'
            }
          },
          lingua: {
            it_IT: 'ITALIANO',
            fr_FR: 'FRANCESE',
            es_ES: 'SPAGNOLO',
            de_DE: 'TEDESCO',
            en_GB: 'INGLESE',
            cambioLingua: 'Cambio lingua',
            linguaImpostata: 'Lingua impostata',
            imposta: 'Imposta'
          },
          bottoni: {
            logout: 'Logout',
            close: 'Chiudi'
          },
          links: 'Link utili',
          info: 'Informativa',
          app: 'Download App',
          store_android: 'Android Play Store',
          store_iOS: 'Apple App Store',
          docs: {
            download: 'Leggi',
            pubblicazione: 'Pubblicato il: ',
            scadenza: 'Scade il:',
            btn: {
              annulla: 'Annulla',
              presaVisione: 'Presa Visione',
              leggi: 'Leggi',
              close: 'Chiudi'
            },
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato',
            0: 'Domenica'
          },
          subMenu: {
            SPORTELLO: 'Sportello Digitale',
            DOCS: 'Documenti',
            ASSENZE: 'Assenze',
            TRASFERTE: 'Trasferte',
            PRESENZE: 'Presenze',
            SOSTITUTO: 'Nomina Sostituto',
            DELSIND: 'Deleghe Sindacali',
            RICARICAAU: 'Torrette Ricarica Auto'
          }
        }
      },
      fr_FR: {
        navLeft: {
          contattaci: {
            contattaci: 'Contactez-nous',
            a: 'À',
            areeDiLavoro: 'Zones de Travail',
            oggetto: 'Sujet',
            messaggio: 'Message',
            allegato: 'Enceinte',
            scegli: 'Choisir...',
            invia: 'Soumettre',
            stato: 'Nation',
            stati: {
              1: 'Italie',
              2: 'France',
              3: 'Espagne',
              4: 'Belgique',
              5: 'Allemagne'
            }
          },
          lingua: {
            it_IT: 'ITALIEN',
            fr_FR: 'FRANÇAIS',
            es_ES: 'ESPAGNOL',
            de_DE: 'ALLEMAND',
            en_GB: 'ANGLAIS',
            cambioLingua: 'Changer la langue',
            linguaImpostata: 'Langue choisie',
            imposta: 'Configurer'
          },
          bottoni: {
            logout: 'Logout',
            close: 'Fermer'
          },
          links: 'Liens utiles',
          info: 'Informativa',
          app: 'Download App',
          store_android: 'Android Play Store',
          store_iOS: 'Apple App Store',
          docs: {
            download: 'Lois',
            pubblicazione: 'Pubblicato il: ',
            scadenza: 'Scade il:',
            btn: {
              annulla: 'Annule',
              presaVisione: 'Presa Visione',
              leggi: 'Lire',
              close: 'Fermer'
            },
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Sabbat',
            0: 'Dimanche'
          },
          subMenu: {
            SPORTELLO: 'Compteur numérique',
            DOCS: 'Documents',
            ASSENZE: 'Absences',
            TRASFERTE: 'Déplacements',
            PRESENZE: 'Présence',
            SOSTITUTO: 'Nomination suppléant',
            DELSIND: 'Bon de Delegation',
            RICARICAAU: 'Bornes de recharge automobile'
          }
        }
      },
      es_ES: {
        navLeft: {
          contattaci: {
            contattaci: 'Contáctenos',
            a: 'Para',
            areeDiLavoro: 'Áreas de Trabajo',
            oggetto: 'Objeto',
            messaggio: 'Mensaje',
            allegato: 'Anexo',
            scegli: 'Elegir...',
            invia: 'Enviar',
            stato: 'País',
            stati: {
              1: 'Italia',
              2: 'Francia',
              3: 'España',
              4: 'Bélgica',
              5: 'Alemania'
            }
          },
          lingua: {
            it_IT: 'ITALIANO',
            fr_FR: 'FRANCÉS',
            es_ES: 'ESPAÑOLA',
            de_DE: 'GERMAN',
            en_GB: 'INGLÉS',
            cambioLingua: 'Cambiar el idioma',
            linguaImpostata: 'Idioma elegido',
            imposta: 'Impuesto'
          },
          bottoni: {
            logout: 'Logout',
            close: 'Cierra'
          },
          links: 'Enlaces útiles',
          info: 'Informativa',
          app: 'Download App',
          store_android: 'Android Play Store',
          store_iOS: 'Apple App Store',
          docs: {
            download: 'Leyes',
            pubblicazione: 'Publicado el : ',
            scadenza: 'Caduca el:',
            btn: {
              annulla: 'Anular',
              presaVisione: 'Presa Visione',
              leggi: 'Leer',
              close: 'Cierra'
            },
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            0: 'Domingo'
          },
          subMenu: {
            SPORTELLO: 'Ventanilla digital',
            DOCS: 'Documentos',
            ASSENZE: 'Ausencia',
            TRASFERTE: 'Viaje',
            PRESENZE: 'Presencias',
            SOSTITUTO: 'Designar Sustitut',
            DELSIND: 'Deleghe Sindacali',
            RICARICAAU: 'Torretas de recarga de coches'
          }
        }
      },
      de_DE: {
        navLeft: {
          contattaci: {
            contattaci: 'Kontaktieren Sie uns',
            a: 'Empfänger',
            areeDiLavoro: 'Arbeitsbereiche',
            oggetto: 'Betreff',
            messaggio: 'Nachricht',
            allegato: 'Anhang',
            scegli: 'Wählen...',
            invia: 'Absenden',
            stato: 'Land',
            stati: {
              1: 'Italien',
              2: 'Frankreich',
              3: 'Spanien',
              4: 'Belgien',
              5: 'Deutschland'
            }
          },
          lingua: {
            it_IT: 'ITALIAN',
            fr_FR: 'FRENCH',
            es_ES: 'SPANISCHE',
            de_DE: 'DEUTSCH',
            en_GB: 'ENGLISCH',
            cambioLingua: 'Ändere die Sprache',
            linguaImpostata: 'Gewählte Sprache',
            imposta: 'Einrichten'
          },
          bottoni: {
            logout: 'Logout',
            close: 'Schließen'
          },
          links: 'Nützliche Links',
          info: 'Informativa',
          app: 'Download App',
          store_android: 'Android Play Store',
          store_iOS: 'Apple App Store',
          docs: {
            download: 'Download',
            pubblicazione: 'Publicado el : ',
            scadenza: 'Caduca el:',
            btn: {
              annulla: 'Anular',
              presaVisione: 'Presa Visione',
              leggi: 'Lesen',
              close: 'Schließen'
            },
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Sabbat',
            0: 'Sonntag'
          },
          subMenu: {
            SPORTELLO: 'Digitaler Schreibtisch',
            DOCS: 'Dokumente',
            ASSENZE: 'Freizeit',
            TRASFERTE: 'Dienstreise',
            PRESENZE: 'AN- / Abwesenheiten',
            SOSTITUTO: 'Vertretung festlegen',
            DELSIND: 'Deleghe Sindacali',
            RICARICAAU: 'Ladesäulen für autos'
          }
        }
      },
      en_GB: {
        navLeft: {
          contattaci: {
            contattaci: 'Contact us',
            a: 'To',
            areeDiLavoro: 'Work Areas',
            oggetto: 'Subject',
            messaggio: 'Message',
            allegato: 'Attached',
            scegli: 'Choose...',
            invia: 'Send',
            stato: 'Country',
            stati: {
              1: 'Italy',
              2: 'France',
              3: 'Spain',
              4: 'Belgium',
              5: 'Germany'
            }
          },
          lingua: {
            it_IT: 'ITALIAN',
            fr_FR: 'FRENCH',
            es_ES: 'SPANISH',
            de_DE: 'GERMAN',
            en_GB: 'ENGLISH',
            cambioLingua: 'Change language',
            linguaImpostata: 'Selected language',
            imposta: 'Select'
          },
          bottoni: {
            logout: 'Logout',
            close: 'Close'
          },
          links: 'Useful Links',
          info: 'Informativa',
          app: 'Download App',
          store_android: 'Android Play Store',
          store_iOS: 'Apple App Store',
          docs: {
            download: 'Download',
            pubblicazione: 'Publicado el : ',
            scadenza: 'Caduca el:',
            btn: {
              annulla: 'Anular',
              presaVisione: 'Presa Visione',
              leggi: 'Read',
              close: 'Close'
            },
            1: 'Monday',
            2: 'Tuesday',
            3: 'Wednesday',
            4: 'Thursday',
            5: 'Friday',
            6: 'Saturday',
            0: 'Sunday'
          },
          subMenu: {
            SPORTELLO: 'Digital Counter',
            DOCS: 'Documents',
            ASSENZE: 'Absence',
            TRASFERTE: 'Business trips',
            PRESENZE: 'Attendance report',
            SOSTITUTO: 'Nomination Suppléant',
            DELSIND: 'Deleghe Sindacali',
            RICARICAAU: 'Car charging stations'
          }
        }
      }
    }
  },
  data() {
    return {
      moment: moment,
      menu: [],
      subMenu: [],
      isCollapse: false,
      activeMenu: [],
      activeApp: '',
      codLang: '',
      isCollapse: true,
      isTitleVisible: true,
      lingua: {
        languageDialogVisible: false,
        lingua: ''
      },
      isIE10: false,
      links: [],
      informativa: {},
      checkInfo: false,
      showModalLinks: false,
      loadingLink: false,
      showModalInfo: false,
      showModalApps: false,
      messaggio: {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      }
    }
  },
  mounted: function () {
    this.codLang = sessionStorage.getItem('codLang')
    this.getMenu()
    //this.loadLinks()
    //this.loadInformativa()
    bus.$on('load_dsh_INF', (dsh_INF) => {
      if (dsh_INF.length === 1) {
        this.$set(this, 'informativa', dsh_INF[0])
        this.$set(this, 'checkInfo', true)
      } else {
        this.$set(this, 'informativa', {})
        this.$set(this, 'checkInfo', false)
      }
    })
  },
  methods: {
    goToArea: function (item, area) {
      let obj = {
        codiApp: area,
        area: area,
        label: item.label
      }
      this.$store.commit('set', { key: 'menu', value: obj })
      if (item.route !== undefined) {
        this.$router.push({ name: item.route })
        this.activeMenu = [this.$store.state.menu.area]
        this.activeApp = ''
      }
    },
    goToApp: function (item, area) {
      let obj = {
        codiApp: item.codiApp,
        area: area,
        label: item.label
      }
      this.$store.commit('set', { key: 'menu', value: obj })
      if (item.route !== undefined) {
        this.$router.push({ name: item.route })
        this.activeMenu = [this.$store.state.menu.area]
        this.activeApp = this.$store.state.menu.codiApp
      }
    },
    getMenu: function () {
      this.$http.get('dipendente/' + this.$store.state.country + '/navMenu')
        .then(response => {
          this.$set(this, 'menu', response.body.data)
          let arrayAree = []
          for (let i = 0; i < response.body.data.length; i++) {
            let obj = {
              area: response.body.data[i].area
              // apps: response.body.data[i].apps
            }
            arrayAree.push(obj)
          }

          let DOCS = this.menu.filter(a => a.area === 'DOCS')

          let APPS = this.menu.filter(a => a.area === 'APPS')
          let SPORTELLO = APPS[0].apps.filter(a => a.codiArea === 'SPORTELLO')
          let ASSENZE = APPS[0].apps.filter(a => a.codiArea === 'ASSENZE')
          let TRASFERTE = APPS[0].apps.filter(a => a.codiArea === 'TRASFERTE')
          let PRESENZE = APPS[0].apps.filter(a => a.codiArea === 'PRESENZE')
          let SOSTITUTO = APPS[0].apps.filter(a => a.codiArea === 'SOSTITUTO')
          let DELSIND = APPS[0].apps.filter(a => a.codiArea === 'DELSIND')
          let RICARICAAU = APPS[0].apps.filter(a => a.codiArea === 'RICARICAAU')

          let subMenu = []
          subMenu['DOCS'] = (DOCS[0].apps)
          subMenu['SPORTELLO'] = (SPORTELLO)
          subMenu['ASSENZE'] = (ASSENZE)
          subMenu['TRASFERTE'] = (TRASFERTE)
          subMenu['PRESENZE'] = (PRESENZE)
          subMenu['SOSTITUTO'] = (SOSTITUTO)
          subMenu['DELSIND'] = (DELSIND)
          subMenu['RICARICAAU'] = (RICARICAAU)
          this.$set(this, 'subMenu', subMenu)

          this.activeMenu = [this.$store.state.menu.area]
          this.activeApp = this.$store.state.menu.codiApp
        })
    },
    setMenu: function () {
      let tree = this.$route.matched
      if (tree !== undefined) {
        let area = (tree[tree.length - 1] !== undefined) ? tree[tree.length - 1].meta.area : ''
        let appName = (tree[2] !== undefined) ? tree[2].meta.appName : ''

        this.activeMenu = [area]
        this.activeApp = appName
      }
    },
    setLanguage: function () {
      if (this.lingua.lingua !== undefined && this.lingua.lingua !== '') {
        this.$set(this, 'codLang', this.lingua.lingua)
        sessionStorage.setItem('codLang', this.lingua.lingua)
        this.$root.$i18n.locale = this.lingua.lingua
        this.$set(this.lingua, 'languageDialogVisible', false)
        bus.$emit('changeLanguage')
      } else {
        this.$set(this.lingua, 'languageDialogVisible', false)
      }
    },
    changeMode: function () {
      this.$set(this, 'isTitleVisible', !this.isTitleVisible)
      setTimeout(() => {
        this.$set(this, 'isCollapse', !this.isCollapse)
        this.$emit('changeMenuMode', this.isCollapse)
      }, 50)
    },
    logout: function () {
      sessionStorage.setItem('token', '')
      sessionStorage.removeItem('token')
      sessionStorage.setItem('token_download', '')
      sessionStorage.removeItem('token_download')
      sessionStorage.setItem('tempPwd', '')
      sessionStorage.removeItem('tempPwd')
      sessionStorage.setItem('reqMail', '')
      sessionStorage.removeItem('reqMail')
      sessionStorage.setItem('vuex', '')
      sessionStorage.removeItem('vuex')
      //sessionStorage.clear()
      this.$router.push({ name: 'Login' })
    },
    loadLinks: function () {
      this.$set(this, 'links', [])
      this.$set(this, 'loadingLink', true)
      this.$set(this, 'showModalLinks', true)
      this.$http.get('dipendente/' + this.$store.state.country + '/link').then(response => {
        if (response.body.rc === 0) {
          if (response.body.data !== undefined) {
            this.$set(this, 'links', response.body.data)
          } else {
            this.$set(this, 'links', [])
          }
          this.$set(this, 'loadingLink', false)
        }
      }, response => {
        this.$set(this, 'links', [])
        this.$set(this, 'loadingLink', false)
      })
    },
    loadInformativa: function () {
      this.$set(this, 'checkInfo', false)
      this.$set(this, 'informativa', {})
      var obj = {
        params: {
          seBlock: 'N',
          tipo: 'INF',
          order: '',
          mesi: '999'
        }
      }
      this.$http.get('communication/' + this.$store.state.country + '/messaggi', obj).then(response => {
        if (response.body.rc === 0 && response.body.data.length === 1) {
          this.$set(this, 'informativa', response.body.data[0])
          this.$set(this, 'checkInfo', true)
        } else {
          this.$set(this, 'informativa', {})
          this.$set(this, 'checkInfo', false)
        }
      }, response => {
        this.$set(this, 'informativa', {})
        this.$set(this, 'checkInfo', false)
      })
    },
    selectMessage: function () {
      this.$set(this, 'showModalInfo', true)
      this.$set(this, 'messaggio', this.informativa)
    },
    closeMessages: function () {
      this.$set(this, 'showModalInfo', false)
      let obj = {
        titolo: '',
        dataPub: '',
        dataExp: '',
        testo: '',
        allegati: []
      }
      this.$set(this, 'messaggio', obj)
    },
    getLabel: function (item) {
      if (item.label === undefined || item.label === null) {
        return "ERROR"
      } else {
        return item.label[this.codLang].toUpperCase()
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../assets/less/general.less";
@import "../assets/less/el-button.less";

.modal-contattaci {
  .elemento {
    .set-font(@size: 14px, @family: 'os-regular', @color: @greenRiva);
    margin-top: 5px;
    margin-bottom: 20px;

    .radio {
      margin-top: 10px;
      color: #007c74;
    }

    .value {
      color: #bbbbbb;
    }

    .el-textarea__inner {
      .set-font(@size: 14px, @color: @grayMedium);
      padding-left: 5px;
      padding-right: 5px;
      border-radius: 0;
    }

    .el-textarea__inner:focus {
      border: 1px solid #007c74;
    }

    .el-input {
      .el-input__inner {
        border: none;
        border-bottom: 1px solid #dcdfe6;
        border-radius: 0;
        height: 22px;
        padding-left: 0;
        line-height: 0;
        .set-font(@size: 14px, @color: @grayMedium);
      }
    }

    .upload-demo {
      .el-upload {
        .el-upload__input {
          display: none !important;
        }
      }
    }
  }

  .col-destra {
    border: 1px solid #e7e7e7;
    margin-top: 11px;
    height: 216px;

    .header-contatto {
      height: 50px;
      background-color: @greenRiva;
      color: @white;

      .icona {
        line-height: 50px;
        padding-top: 7px;
      }

      .nome {
        line-height: 50px;
      }
    }

    .dati-contatto {
      .dato {
        color: @greenRiva;
        margin-top: 20px;

        .dato-label {
          text-align: center;
          padding-top: 0;
        }
      }
    }
  }
}

.modal-lingua {
  .elemento {
    .set-font(@size: 14px);
    margin-top: 5px;
    margin-bottom: 20px;

    .my-label {
      color: @greenRiva;
    }

    .radio {
      margin-top: 10px;
      color: @greenRiva;
    }

    .value {
      color: #bbbbbb;
    }
  }
}

.modal-link {
  .elemento {
    margin-top: 5px;
    margin-bottom: 20px;

    .linkDetail {
      height: 40px;
      line-height: 30px;
      position: relative;
      padding-bottom: 10px;
      display: flex;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-transform: lowercase;

      a {
        .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');

        .applicazione {
          text-transform: uppercase;
          .set-font(@size: 14px, @color: #485eb5, @weight: bold, @family: 'os-regular');
        }

        .url {
          text-transform: lowercase;
          .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
        }
      }

      a:hover {
        text-decoration: none;
      }

      a:focus {
        text-decoration: none;
      }
    }
  }
}

.nav-left {
  .servizi {
    z-index: 100;
    color: @white;
    position: absolute;
    bottom: 0;
    padding-bottom: 15px;
    width: 55px;
    text-align: center;
    // border-top: 1px solid @white;
    // padding-top: 10px;
    box-shadow: inset 0px 3px 10px #454848;
    -webkit-box-shadow: inset 0px 3px 10px #454848;
    -moz-box-shadow: inset 0px 3px 10px #454848;
    -o-box-shadow: inset 0px 3px 10px #454848;

    .linea {
      width: 45px;
      height: 1px;
      background-color: @white;
      margin-left: 5px;
      margin-bottom: 10px;
    }

    .servizio {
      margin-top: 20px;
    }
  }

  // Menu generale (e grande)
  .el-menu {
    width: 132px;
    border-right: 1px solid #eef4f9;
  }

  .left-bar {
    .change-mode {
      color: @white;
      height: 53px;
      line-height: 53px;
    }

    z-index: 10;
    width: 131px;
    box-shadow: inset -6px 4px 5px #454848;
    -webkit-box-shadow: inset -6px 4px 5px #454848;
    -moz-box-shadow: inset -6px 4px 5px #454848;
    -o-box-shadow: inset -6px 4px 5px #454848;
    float: left;
    background-color: @greenRiva;
    color: @white;
    text-align: center;
    padding-top: 53px;
    padding-left: 0 !important;
    border-right: 0;

    .titolo {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      font-family: 'os-semibold';
      text-align: center;
      padding-top: 13px;
      padding-bottom: 7px;
      border-bottom: 1px solid #eef4f9;
      height: 100%;

      .icon {
        right: 15px;
        margin: auto;
        margin-top: 5px;
        margin-bottom: 5px;
      }

      .ie10 {
        height: 30px;
      }

      .my-label {
        margin-top: 5px;
        word-wrap: break-word;
        width: 90px;
        white-space: normal;
        line-height: 13px;
        font-size: 12px;
      }
    }

    a {
      color: @white;
    }

    .label-menu {
      width: 90%;
      word-wrap: break-word;
      border-left: 2px solid @white;
      margin-left: 10px;
      padding-left: 15px;
      height: 100%;
      .set-font(@size: 13px; @color: @white);
      vertical-align: middle;
      line-height: 18px;
      padding-top: 13px;
      text-align: left;
      display: inline-block;
    }

    .cerchio {
      margin-left: -26px;
      width: 20px;
      height: 20px;
      float: left;
    }

    .applicazione {
      float: left;
      width: 72px;
    }

    .el-menu-item {
      height: 120px;
      line-height: 38px;
      color: @white;
      margin-top: -3px;

      .my-label {
        width: 100%;
      }
    }

    .el-submenu__icon-arrow {
      display: none;
    }

    .el-submenu__title {
      height: 120px;
      line-height: 38px;
      color: @white;
      margin-top: -3px;

      .my-label {
        width: 100%;
      }
    }

    .el-submenu__title:hover {
      color: @greenRiva !important;
      background-color: #e6fbfa;
    }

    .is-opened {
      .label {
        color: @greenRiva;
      }

      .el-submenu__title {
        color: @greenRiva !important;
        box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
        -webkit-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
        -moz-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
        -o-box-shadow: -4px -4px 5px #454848, -4px 4px 5px #454848;
        z-index: 10;
      }

      background-color: #eef4f9;
    }

    .el-menu-item {
      box-shadow: inset -10px 0 6px -4px #454848;
      -webkit-box-shadow: inset -10px 0 6px -4px #454848;
      -moz-box-shadow: inset -10px 0 6px -4px #454848;
      -o-box-shadow: inset -10px 0 6px -4px #454848;
      min-width: 0;
      max-width: 100%;
      padding-left: 0 !important;
      padding-right: 0 !important;
      padding-top: 0 !important;
      text-align: center;
      overflow: hidden;
      background-color: @greenRiva;
      color: @white;
      height: 63px;
      white-space: pre-wrap;
    }

    .label-menu {
      .applicazione {
        .set-font(@family: 'os-regular'; @color: #dcd9d9; @size: 13px);

        &.selected-app {
          .set-font(@family: 'os-semibold'; @color: @white; @size: 13px);
        }
      }
    }
  }

  .el-menu-vertical-demo {
    min-height: 100%;
  }

  // Menu piccolo
  .el-menu--collapse {
    &.left-bar {
      width: 55px;
      padding-top: 10px;

      .el-menu-item {
        margin-bottom: 5px;
        height: 55px;
        padding: 0 !important;

        &.is-active-custom {
          background-color: #eef4f9;
          color: @greenRiva;
          box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
          -webkit-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
          -moz-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
          -o-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
          z-index: 10;
        }

        .titolo {
          padding-top: 10px;
          border-bottom: 0;
          border: none;
        }
      }

      .el-submenu {
        margin-bottom: 5px;

        .el-submenu__title {
          height: 55px;
          padding: 0 !important;

          .titolo {
            padding-top: 10px;
            border-bottom: 0;
          }
        }

        &.is-active-custom {
          background-color: #eef4f9;

          .el-submenu__title {
            color: @greenRiva;
            box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
            -webkit-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
            -moz-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
            -o-box-shadow: -4px -2px 3px #454848, -4px 2px 3px #454848;
            z-index: 10;

            &.is-opened {
              box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
              -webkit-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
              -moz-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
              -o-box-shadow: -2px -2px 3px #454848, -2px 2px 3px #454848;
            }
          }
        }

        &.is-opened {
          background-color: #e6fbfa;
        }
      }
    }
  }
}

.el-menu--vertical {
  .el-menu {
    background-color: #e6fbfa;
    margin-left: 0;
    box-shadow: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    -o-box-shadow: none;
  }

  .el-menu-item:hover {
    .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
    background-color: #e6fbfa;
  }

  .el-menu-item {
    .label-menu {
      display: flex;

      .fa-icon {
        line-height: 35px;
        height: 35px;
        margin-right: 10px;
        color: #bbb;
      }
    }

    .set-font(@family: 'os-regular', @color: @textTable, @size: 12px);
    letter-spacing: 1px;
    text-transform: uppercase;
    height: 35px;
    line-height: 35px;

    .selected-app {
      .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
    }

    &.intestazione-area {
      .set-font(@family: 'os-semibold', @color: @greenRiva, @size: 12px);
      height: 25px;
      line-height: 25px;
      margin-bottom: 5px;
    }
  }

  .el-submenu {
    .el-submenu__title {
      .set-font(@family: 'os-regular', @color: @textTable, @size: 12px);
      letter-spacing: 1px;
      text-transform: uppercase;
      height: 35px;
      line-height: 35px;

      .sub-titolo {
        display: flex;

        .fa-icon {
          line-height: 35px;
          height: 35px;
          margin-right: 10px;
          color: #bbb;
        }

        .titolo {
          margin-right: 15px;
        }
      }
    }

    .el-submenu__title:hover {
      // .set-font(@family: 'os-semibold', @color: @textTable, @size: 12px);
      background-color: #e6fbfa;
    }

    .el-menu-item {
      text-transform: capitalize;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavLeft.vue